import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { SearchBar } from '@fiverr-private/search_bar';
import { translate } from '@fiverr-private/i18n-react';
import PopularServices from '../PopularServices';

export const BrowseServicesTab = () => (
    <>
        <Container width="100%" maxWidth="100%">
            <SearchBar
                placeholder={translate('logged_out_homepage.hero.search')}
                source="main_banner"
                submitButtonType="button_inside"
                theme="dark"
            />
        </Container>
        <PopularServices />
    </>
);
